import { api } from "api/api";
import { HistoricoFiscal } from "model/vendas/NotaFiscalSaidaHistoricoFiscal";

export default class NotaFiscalSaidaHistoricoFiscalService {
    async listar(id: number): Promise<HistoricoFiscal> {
        return (await api.get<HistoricoFiscal>(`/notaFiscalSaida/${id}/historicoFiscal`)).data;
    }
    async repetirIntegracao(id: number, pendencia: number): Promise<void> {
        await api.post(`/notaFiscalSaida/${id}/pendencias/${pendencia}/repetir`);
    }
}
